import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';

import { Helmet } from 'react-helmet';

const data = [
  {
    title: "Upcoming Batches",
    desc: "Check out the schedule for our upcoming training batches and reserve your seat early.",
    url: "#popup-upcoming",
    color: "#000",
    background: "linear-gradient(135deg, #fceabb 0%, #f8b500 100%)",
  },
  {
    title: "Training Syllabus",
    desc: "Download the detailed syllabus for each of our training programs.",
    url: "https://drive.google.com/drive/folders/1in9pY2TTPgd400B5KxwIzfz6-U6ZLaKs",
    color: "#fff",
    background: "linear-gradient(135deg, #e67e22, #f39c12)",
  },
  {
    title: "Placement Video Testimonials",
    desc: "Watch real success stories from students who got placed through our institute.",
    url: "https://www.youtube.com/playlist?list=PLfr5N_DIRx0OYQxmsYmn2Le41aIKIwlH2",
    color: "#fff",
    background: "linear-gradient(135deg, #1abc9c, #16a085)",
  },
  {
    title: "Follow Us on Instagram",
    desc: "Stay updated with our events, student achievements and more via Instagram.",
    url: "https://www.instagram.com/fortunecloud/",
    color: "#fff",
    background: "linear-gradient(135deg, #e84393, #fd79a8)",
  },
  {
    title: "Like Us on Facebook",
    desc: "Join our Facebook community and stay in the loop with all the latest updates.",
    url: "https://www.facebook.com/fortunecloudtechnologies",
    color: "#fff",
    background: "linear-gradient(135deg, #2980b9, #6dd5fa)",
  },
];

const whatsappBranches = [
  {
    title: "Pune Office",
    url: "https://api.whatsapp.com/send/?phone=919766439090&amp;text=hi-message from quick info link&amp;type=phone_number&amp;app_absent=0",
  },
  {
    title: "Pimpri Office",
    url: "https://api.whatsapp.com/send/?phone=918002949090&amp;text=hi-message from quick info link&amp;type=phone_number&amp;app_absent=0",
  },
  {
    title: "Bengaluru Office",
    url: "https://api.whatsapp.com/send/?phone=917090119090&amp;text=hi-message from quick info link&amp;type=phone_number&amp;app_absent=0",
  },
];

export const Quickinfo = () => {
  const [showPopup, setShowPopup] = useState(false);

  const [batchSchedule, setBatchSchedule] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBatchSchedule = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE}/batchschedule/`
        );
        const data = await response.json();
        setBatchSchedule(data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching Batch Schedule:", error);
        setLoading(false);
      }
    };

    fetchBatchSchedule();
  }, []);

  const handleUpcomingClick = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  if (batchSchedule.length === 0 && !loading) {
    return (
      <>
      <Helmet>
              <title>Fortune Cloud Technologies | Quick Info</title>
              <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
              <meta name="robots" content="index, follow" />
      </Helmet>
      <div className="container my-2">

        <div className='text-center'>
          <Link className="navbar-brand text-center" to="/" title="Fortune Cloud Logo" aria-label="Fortune Cloud Logo">
            <img src="/assets/images/fctlogo.png" alt="Fortune Cloud Technologies Logo" width="140" className="img-fluid" loading="lazy"/>
          </Link><br/>

          <Link to="/">Home</Link> |
          &nbsp;<Link to="/About-Us">About Us</Link> |
          &nbsp;<Link to="/Contact">Contact</Link>
        </div><br/>

        {/* WhatsApp Section */}
        <div className="row justify-content-center">
          <div className="col-lg-12 mb-4">
            <div className="card h-100 shadow-sm border-0 whatsApp-card">
              <div className="card-body text-center">
                <h5 className="card-title text-success fw-bold mb-3">
                  Chat with Us on WhatsApp
                </h5>
                <div className="row">
                  {whatsappBranches.map((branch, idx) => (
                    <div key={idx} className="col-md-4 mb-2">
                      <a
                        href={branch.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center"
                      >
                        <i className="fab fa-whatsapp me-2"></i> {branch.title}
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Info Cards */}
          {data.map((item, index) => (
            <div key={index} className="col-lg-4 col-md-6 col-sm-10 mb-4">
              <div
                className="card shadow-sm border-0 h-100 info-card"
                style={{ background: item.background, color: item.color }}
              >
                <div className="card-body text-center d-flex flex-column">
                  <h5
                    className="card-title fw-bold"
                    style={{ color: item.color }}
                  >
                    {item.title}
                  </h5>
                  <p className="card-text" style={{ color: item.color }}>
                    {item.desc}
                  </p>
                  {item.title === "Upcoming Batches" ? (
                    <button
                      className="btn btn-custom mt-auto w-100"
                      onClick={handleUpcomingClick}
                    >
                      Go to Page
                    </button>
                  ) : (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-auto"
                    >
                      <button className="btn btn-custom mt-2 w-100">
                        Go to Page
                      </button>
                    </a>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social Media Icons */}
        <div className="text-center mt-1">
          <a href="https://www.facebook.com/fortunecloudtechnologies">
            <i className="fab fa-facebook fa-2x text-primary mx-2"></i>
          </a>
          <a href="https://www.instagram.com/fortunecloud/">
            <i className="fab fa-instagram fa-2x text-danger mx-2"></i>
          </a>
          <a href="https://www.youtube.com/playlist?list=PLfr5N_DIRx0OYQxmsYmn2Le41aIKIwlH2">
            <i className="fab fa-youtube fa-2x text-danger mx-2"></i>
          </a>
          <a href="https://api.whatsapp.com/send/?phone=919766439090&text=hi-message%20from%20quick%20info%20link&type=phone_number&app_absent=0">
            <i className="fab fa-whatsapp fa-2x text-success mx-2"></i>
          </a>
          {/* <a href="#">
            <i className="fas fa-envelope fa-2x text-secondary mx-2"></i>
          </a> */}
        </div>

        {/* Popup for Upcoming Batches */}
        {showPopup && (
          <div className="popup-modal" onClick={closePopup}>
            <div
              className="popup-content myfont1 "
              onClick={(e) => e.stopPropagation()}
            >
              <button className="popup-close" onClick={closePopup}>
                &times;
              </button>
              <h4 className="fw-bold">Upcoming Batches</h4>
              {/* <p>Check out our new batches!</p> */}
              <div className="row">
                {/* {["dads-12-may-2025-10-12.webp", "dads-12-may-2025-10-12.webp"].map((img, idx) => (
                <div className="col-md-6">
                    <img key={idx} src={`assets/upcoming_batches/${img}`}alt={`Upcoming ${idx}`}/>
                </div>
                ))} */}
                <h2>No Batch Posters</h2>
              </div>
              <button
                className="btn btn-danger mt-3 fw-bold"
                onClick={closePopup}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
      </>
    );
  }

  return (
    <>
    <Helmet>
              <title>Fortune Cloud Technologies | Quick Info</title>
              <meta name="description" content="Explore courses and training programs at Fortune Cloud Technologies. Learn with experts and get placed." />
              <meta name="robots" content="index, follow" />
      </Helmet>
    <div className="container my-5">

      <div className='text-center'>
          <Link className="navbar-brand text-center" to="/" title="Fortune Cloud Logo" aria-label="Fortune Cloud Logo">
            <img src="/assets/images/fctlogo.png" alt="Fortune Cloud Technologies Logo" width="140" className="img-fluid" loading="lazy"/>
          </Link><br/>

          <Link to="/">Home</Link> |
          &nbsp;<Link to="/About-Us">About Us</Link> |
          &nbsp;<Link to="/Contact">Contact</Link>
        </div><br/>
        
      {/* WhatsApp Section */}
      <div className="row justify-content-center">
        <div className="col-lg-12 mb-4">
          <div className="card h-100 shadow-sm border-0 whatsApp-card">
            <div className="card-body text-center">
              <h5 className="card-title text-success fw-bold mb-3">
                Chat with Us on WhatsApp
              </h5>
              <div className="row">
                {whatsappBranches.map((branch, idx) => (
                  <div key={idx} className="col-md-4 mb-2">
                    <a
                      href={branch.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-outline-success w-100 d-flex align-items-center justify-content-center"
                    >
                      <i className="fab fa-whatsapp me-2"></i> {branch.title}
                    </a>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Info Cards */}
        {data.map((item, index) => (
          <div key={index} className="col-lg-4 col-md-6 col-sm-10 mb-4">
            <div
              className="card shadow-sm border-0 h-100 info-card"
              style={{ background: item.background, color: item.color }}
            >
              <div className="card-body text-center d-flex flex-column">
                <h5
                  className="card-title fw-bold"
                  style={{ color: item.color }}
                >
                  {item.title}
                </h5>
                <p className="card-text" style={{ color: item.color }}>
                  {item.desc}
                </p>
                {item.title === "Upcoming Batches" ? (
                  <button
                    className="btn btn-custom mt-auto w-100"
                    onClick={handleUpcomingClick}
                  >
                    Go to Page
                  </button>
                ) : (
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-auto"
                  >
                    <button className="btn btn-custom mt-2 w-100">
                      Go to Page
                    </button>
                  </a>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Social Media Icons */}
      <div className="text-center mt-1">
        <a href="https://www.facebook.com/fortunecloudtechnologies">
          <i className="fab fa-facebook fa-2x text-primary mx-2"></i>
        </a>
        <a href="https://www.instagram.com/fortunecloud/">
          <i className="fab fa-instagram fa-2x text-danger mx-2"></i>
        </a>
        <a href="https://www.youtube.com/playlist?list=PLfr5N_DIRx0OYQxmsYmn2Le41aIKIwlH2">
          <i className="fab fa-youtube fa-2x text-danger mx-2"></i>
        </a>
        <a href="https://api.whatsapp.com/send/?phone=919766439090&text=hi-message%20from%20quick%20info%20link&type=phone_number&app_absent=0">
          <i className="fab fa-whatsapp fa-2x text-success mx-2"></i>
        </a>
        {/* <a href="#">
          <i className="fas fa-envelope fa-2x text-secondary mx-2"></i>
        </a> */}
      </div>

      {/* Popup for Upcoming Batches */}
      {showPopup && (
        <div className="popup-modal" onClick={closePopup}>
          <div
            className="popup-content myfont1 "
            onClick={(e) => e.stopPropagation()}
          >
            <button className="popup-close" onClick={closePopup}>
              &times;
            </button>
            <h4 className="fw-bold">Upcoming Batches</h4>
            <p>Check out our new batches!</p>
            <div className="row">
              {/* {["dads-12-may-2025-10-12.webp", "dads-12-may-2025-10-12.webp"].map((img, idx) => ( */}
              {batchSchedule
              .filter(item => item.posterimage)           // ⬅️ keep only those that have an image
              .map((item, idx) => (
                <div className="col-md-6" key={item._id ?? idx}>
                  <img
                    src={`${process.env.REACT_APP_API_BASE}/uploads/batchSchedule/${item.posterimage}`}
                    alt={item.course || `Upcoming ${idx}`}
                    className="img-fluid rounded-3"
                    loading="lazy"
                  />
                </div>
            ))}

            </div>
            <button
              className="btn btn-danger mt-3 fw-bold"
              onClick={closePopup}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
    </>
  );
};
